export default {
  nav: {
    home: 'HOME',
    about: 'ABOUT',
    services: 'SERVICES',
    contact: 'CONTACT',
    quote: 'Get Quote',
    phone: '(657) 433-8533',
    admin: 'Admin Access',
  },
  hero: {
    badge: 'Professional Screen & Door Repair Service',
    title: 'Screen Repair &\nInstallation for\nWindows & Doors',
    description: 'The Screen Squad specializes in screen and door repair, replacement, and installation. Fast, professional, and reliable service in Santa Ana, California and surrounding areas. Need your screens repaired or replaced? We have got you covered!',
    locationBadge: 'SANTA ANA, CA',
    locationSub: 'Local & Trusted',
    scheduleBadge: 'FAST SERVICE',
    scheduleSub: 'Professional Care',
    quoteBadge: 'FREE ESTIMATES',
    quoteSub: 'No Commitment',
    stats: {
      experience: 'Fast',
      experienceLabel: 'Fast Service',
      freeEstimates: 'Free',
      freeEstimatesLabel: 'Free Estimates',
      familyBusiness: 'Pro',
      familyBusinessLabel: 'Reliable Work',
    },
    form: {
      title: 'Get Your Free Quote Today! 👇',
      subtitle: 'We will respond quickly',
      fullName: 'Full Name',
      fullNamePlaceholder: 'Enter your full name',
      email: 'Email Address',
      emailPlaceholder: 'Enter your email address',
      phone: 'Phone Number',
      phonePlaceholder: 'Enter your phone number',
      service: 'Service Needed',
      servicePlaceholder: 'Select a service',
      services: {
        sprayFoam: 'New Screen Fabrication & Installation',
        batt: 'Screen & Door Repair',
        roll: 'Window Screens',
        cellulose: 'Door Screens',
        blownIn: 'Sliding Door Repair',
        attic: 'Window Screen Service',
        wall: 'On-Site Service',
        crawlSpace: 'Pet Door Screens',
        metalBuilding: 'Security Screens',
        general: 'General Consultation',
      },
      submit: 'Request Free Quote',
      scroll: 'Scroll',
    },
    topBadges: {
      professional: 'PROFESSIONAL SERVICE',
      mobile: 'MOBILE SERVICE',
      fast: 'FAST SAME-DAY SERVICE',
    },
    titleLine1: 'Installation of',
    titleHighlight: 'Screens',
    titleLine2: 'for Windows & Doors',
    descriptionPart1: 'Repair, replacement and installation of ',
    descriptionHighlight1: 'screens',
    descriptionPart2: ' for windows and doors. Fast, professional and reliable service in ',
    descriptionHighlight2: 'Santa Ana, California',
    descriptionPart3: ' and surrounding areas.',
    badges: {
      fast: 'FAST SERVICE',
      fastSub: 'Same Day',
      materials: 'HIGH-QUALITY MATERIALS',
      quotes: 'FREE ESTIMATES',
      guarantee: 'GUARANTEED WORK',
    },
    cta: {
      call: 'CALL NOW',
      whatsapp: 'QUOTE VIA WHATSAPP',
      whatsappSub: 'Response in minutes',
    },
    google: {
      rating: '5.0 ON GOOGLE',
      reviews: 'OVER 20 HAPPY CUSTOMERS',
      viewReviews: 'VIEW REVIEWS',
    },
    bottomBar: {
      servicesTitle: 'OUR SERVICES',
      areasTitle: 'AREAS WE SERVE',
      services: {
        windowScreens: 'WINDOW SCREENS',
        slidingDoors: 'SCREEN SLIDING DOORS',
        retractable: 'RETRACTABLE SCREENS',
        petDoors: 'PET DOORS',
        solarScreens: 'SOLAR SCREENS',
        repair: 'SCREEN REPAIR',
        custom: 'CUSTOM SCREENS',
      },
      areas: {
        santaAna: 'Santa Ana',
        tustin: 'Tustin',
        orange: 'Orange',
        gardenGrove: 'Garden Grove',
        anaheim: 'Anaheim',
        irvine: 'Irvine',
        costaMesa: 'Costa Mesa',
        fountainValley: 'Fountain Valley',
        huntingtonBeach: 'Huntington Beach',
        newportBeach: 'Newport Beach',
        more: 'And More',
      },
    },
  },
  statsBar: {
    experience: 'Fast',
    experienceLabel: 'Fast Service',
    experienceDesc: 'Quick and efficient screen repairs and installations.',
    satisfaction: '100%',
    satisfactionLabel: 'Satisfaction Guaranteed',
    satisfactionDesc: 'Customer satisfaction guaranteed on every screen project.',
    freeQuotes: 'Free',
    freeQuotesLabel: 'No-Cost Estimates',
    freeQuotesDesc: 'Free estimates with no commitment. Get your personalized quote today.',
    local: 'Local',
    localLabel: 'Family Owned',
    localDesc: 'Family business in Santa Ana, California. Serving our community.',
  },
  about: {
    label: 'About Us',
    title: 'A Company Built on Quality & Trust',
    description1: 'The Screen Squad specializes in professional screen and door solutions for windows and doors. Our team is committed to delivering high-quality results, from quick repairs to complete installations. Direct on-site service with personalized attention.',
    tagline: 'Serving Santa Ana, California and surrounding areas. Bugs Out!',
    badge: 'The',
    badgeLabel: 'Screen Squad',
    services: {
      sprayFoam: 'Window Screens',
      battRoll: 'Door Screens',
      atticWall: 'Screen Repair',
      commercial: 'On-Site Service',
    },
    cta: 'Learn More About Us',
  },
  ctaBanner: {
    badge: 'Request Your Free Quote Today',
    title: 'Screens Fixed Fast — Bugs Out!',
    description: 'Let The Screen Squad handle your screens and doors so you can enjoy a fresh, ventilated, bug-free home. Professional on-site service in Santa Ana, California and surrounding areas.',
    quoteBtn: 'Request Free Quote',
    callBtn: '(657) 433-8533',
  },
  services: {
    label: 'Our Services',
    title: 'Complete Screen Solutions for Windows & Doors',
    description: 'We offer a full range of screen repair, replacement, and installation services for homes in Santa Ana, California and surrounding areas.',
    areaBadge: 'Local',
    areaLabel: 'Service Area',
    areaSub: 'Santa Ana, California & Surrounding Areas',
    cardTitle: 'Our Professional Screen Services',
    cardDesc: 'From quick repairs to complete installations, we have your windows and doors covered.',
    cta: 'View All',
    cards: {
      sprayFoam: {
        title: 'New Screen Fabrication & Installation',
        desc: 'We fabricate and install new custom screens for windows and doors. High-quality materials that withstand daily wear and keep insects out.',
        cta: 'Request This Service',
      },
      battRoll: {
        title: 'Screen & Door Repair',
        desc: 'We repair torn, broken, or worn screens for windows and doors. Fast and efficient service to restore functionality to your screens.',
        cta: 'Request This Service',
      },
      cellulose: {
        title: 'Window Screens',
        desc: 'Installation and repair of screens for all types of windows. From sliding windows to double-hung, we ensure a perfect fit.',
        cta: 'Request This Service',
      },
    },
    overlay: {
      reliable: 'Reliable & Professional',
      reliableDesc: 'Trained professionals with experience on every job.',
      freeQuotes: 'Free Estimates',
      freeQuotesDesc: 'Contact us today for a free, no-commitment estimate.',
    },
  },
  whyChooseUs: {
    badge: 'Why Choose Us',
    label: 'The Screen Squad — Why Choose Us',
    title: 'Our Promise: Perfect Screens, Happy Customers',
    description: 'The Screen Squad offers consistent, high-quality screen repair and installation services. We prioritize speed, reliability, and treat every home with the care it deserves.',
    stats: {
      satisfaction: { label: 'Customer Satisfaction', value: '100%' },
      onTime: { label: 'Service Completed On Time', value: '98%' },
      reliability: { label: 'Service Reliability', value: '99%' },
      quality: { label: 'Quality Results', value: '97%' },
    },
  },
  howItWorks: {
    label: 'How It Works',
    title: 'Your Screen Service in 4 Simple Steps',
    steps: {
      1: {
        title: 'Contact Us',
        desc: 'Reach out by phone, email, or our online form. Tell us what screens you need repaired or installed. We are ready to help and respond quickly.',
      },
      2: {
        title: 'Evaluation & Free Quote',
        desc: 'We visit your property, evaluate your screens, and give you a clear, fair estimate. No hidden fees, no surprises — just honest pricing.',
      },
      3: {
        title: 'Professional Repair or Installation',
        desc: 'Our team arrives on time with professional tools. We repair or install your screens with excellent results on every project.',
      },
      4: {
        title: 'Inspection & Warranty',
        desc: 'We carefully inspect every detail to ensure a perfect result. Your satisfaction is our priority. If something is not right, we come back and fix it at no extra cost.',
      },
    },
  },
  reviews: {
    label: 'Google Reviews',
    labelSub: 'Verified reviews from real customers',
    title: 'What Our Customers Say',
    description: 'Real reviews from homeowners in Santa Ana, California and surrounding areas. We are proud of our reputation.',
    rating: '5.0',
    ratingLabel: 'out of 5 stars',
    count: '50+',
    countLabel: 'verified reviews',
    google: 'Google',
    leaveReview: 'Leave Us a 5-Star Review on Google',
    reviews: {
      1: {
        text: 'The Screen Squad did an incredible job replacing the screens on all my windows. They arrived on time, were super professional, and the price was excellent. Now I can open my windows without mosquitoes coming in. Highly recommended!',
        author: 'Maria G.',
        verified: 'Verified Customer · June 2026',
      },
      2: {
        text: 'I hired The Screen Squad to repair my sliding door screen. They came the same day, fixed everything in under an hour, and left everything clean. Fair price and exceptional service. I will definitely call them again.',
        author: 'Carlos R.',
        verified: 'Verified Customer · May 2026',
      },
      3: {
        text: 'Excellent on-site service. They came to my house in Santa Ana, measured my window screens, and installed them the next day. Professional quality and very friendly. My dog is also happy with his new pet door.',
        author: 'Jennifer T.',
        verified: 'Verified Customer · April 2026',
      },
    },
  },
  finalCta: {
    label: 'Your Comfort. Our Commitment. Bugs Out!',
    title: 'Invest in Your Home\'s Comfort',
    description: 'Well-installed screens bring more than just comfort — they keep insects out, allow natural breeze, and improve the quality of life in your home. The Screen Squad is ready to transform your windows and doors in Santa Ana, California.',
    quoteBtn: 'Request Free Quote',
    callBtn: '(657) 433-8533',
  },
  footer: {
    description: 'The Screen Squad specializes in screen and door repair, replacement, and installation for windows and doors in Santa Ana, California and surrounding areas. Fast, professional, and reliable service directly at your property.',
    phone: '(657) 433-8533',
    email: 'thescreensquadcrew@gmail.com',
    navTitle: 'Navigation',
    nav: {
      home: 'Home',
      services: 'Services',
      about: 'About',
      contact: 'Contact',
    },
    servicesTitle: 'Our Services',
    services: {
      sprayFoam: 'Window Screens',
      batt: 'Door Screens',
      cellulose: 'Screen Repair',
      attic: 'Sliding Doors',
      wall: 'New Screens',
      crawlSpace: 'On-Site Service',
    },
    contactTitle: 'Contact',
    address: '3647 W McFadden Ave\nSanta Ana, CA 92704',
    hoursTitle: 'Business Hours',
    hoursWeekday: 'Mon - Sat: 8:00 AM - 6:00 PM',
    hoursWeekend: 'Sun: Closed',
    copyright: '© 2026 The Screen Squad. All rights reserved.',
    serving: 'Serving Santa Ana, California and surrounding areas.',
  },
  aboutPage: {
    heroTitle: 'ABOUT US',
    storyLabel: 'OUR STORY',
    storyTitle: 'A Company Built on Quality & Trust',
    stats: {
      experienceLabel: 'Fast Service',
      satisfactionLabel: 'Satisfaction Guaranteed',
      quotesNumber: 'Quotes',
      quotesLabel: 'Available',
    },
    visionLabel: 'Our Vision',
    visionText: 'To become the most reliable screen repair service in Orange County by offering exceptional workmanship, quality materials, and outstanding customer service. We believe every home deserves to enjoy natural breeze without worrying about insects.',
    faqLabel: 'FREQUENTLY ASKED QUESTIONS',
    faqTitle: 'Learn More About The Screen Squad',
    faqDesc: 'We answer the most common questions from homeowners in Santa Ana, California interested in our screen and door services.',
    approachLabel: 'OUR APPROACH',
    approachTitle: 'Quality Work, Fair Prices, Happy Customers',
    approachDesc: 'The Screen Squad offers reliable and professional screen repair and installation services with a focus on quality results and customer satisfaction. We prioritize punctuality, excellent workmanship, and treating every home with the care it deserves.',
    features: {
      experience: 'Fast & Professional Service',
      experienceDesc: 'Our team has years of experience in the industry. On every project, we ensure expert repairs and installations with reliable results.',
      residential: 'Residential & Commercial Service',
      residentialDesc: 'From single-family homes to commercial businesses, we handle projects of all sizes with the same level of care and professionalism.',
      materials: 'High-Quality Materials',
      materialsDesc: 'We use only top-grade materials to ensure durable screens that withstand daily wear and California weather.',
      pricing: 'Competitive Pricing & Free Quotes',
      pricingDesc: 'No hidden fees, no surprises. We offer honest, transparent pricing with free quotes for every project.',
      satisfaction: 'Satisfaction Guaranteed',
      satisfactionDesc: 'We treat every home as if it were our own. Your comfort and satisfaction are our top priority on every job.',
    },
    ctaQuote: 'Request Free Quote',
    ctaViewAll: 'View All',
  },
  servicesPage: {
    heroTitle: 'OUR SERVICES',
    label: 'Our Services',
    title: 'Complete Screen Solutions for Every Need',
    description: 'We offer a full range of screen repair, replacement, and installation services for homes and businesses in Santa Ana, California and surrounding areas.',
    cards: {
      sprayFoam: {
        title: 'New Screen Fabrication & Installation',
        desc: 'We fabricate and install new custom screens for windows and doors of all types. We use high-quality materials that guarantee durability and resistance to daily wear.',
      },
      battRoll: {
        title: 'Screen & Door Repair',
        desc: 'We repair torn, broken, or worn screens for windows and doors. From small tears to complete frame replacement, we restore functionality to your screens.',
      },
      cellulose: {
        title: 'Window Screens',
        desc: 'Specialized installation and repair of screens for all types of windows. Sliding windows, double-hung, awning, and more. Perfect fit guaranteed.',
      },
      atticWall: {
        title: 'Door Screens',
        desc: 'Comprehensive screen services for sliding doors, French doors, patio doors, and more. Includes track, roller, handle, and mesh replacement.',
      },
      crawlSpace: {
        title: 'Sliding Door Repair',
        desc: 'We repair sliding doors with roller, track, handle, and screen issues. Let your sliding door work like new with our professional service.',
      },
      metalBuilding: {
        title: 'On-Site Service',
        desc: 'We come directly to your property in Santa Ana and surrounding areas. We bring all the tools and materials needed to complete the job in a single visit.',
      },
    },
    areasLabel: 'SERVICE AREAS',
    areasTitle: 'Serving Santa Ana, California & Surrounding Areas',
    areasDesc: 'The Screen Squad proudly offers screen repair and installation services in the following communities and nearby areas.',
    area1: {
      title: 'Santa Ana',
      desc: 'Screen services for homes and businesses throughout Santa Ana, California.',
    },
    area2: {
      title: 'Orange County',
      desc: 'Screen repair and installation for residential and commercial properties in the Orange County area.',
    },
    area3: {
      title: 'Surrounding Areas',
      desc: 'Screen services for homes and businesses in communities near Santa Ana.',
    },
    finalCta: 'Ready for Perfect Screens & a Bug-Free Home?',
    finalCtaDesc: 'Contact us today for a free estimate. No commitment, just honest prices and professional service for your home or business.',
    requestService: 'Request Service',
  },
  contactPage: {
    heroTitle: 'CONTACT US',
    callLabel: 'CALL US',
    emailLabel: 'EMAIL US',
    socialLabel: 'FOLLOW US',
    areaLabel: 'SERVICE AREA',
    areaSub: 'Family Business',
    formTitle: 'REQUEST A FREE QUOTE',
    formSubtitle: 'Complete the form and we will respond quickly',
    name: 'First Name',
    namePlaceholder: 'Enter your first name',
    lastName: 'Last Name',
    lastNamePlaceholder: 'Enter your last name',
    email: 'Email Address',
    emailPlaceholder: 'Enter your email address',
    phone: 'Phone Number',
    phonePlaceholder: 'Enter your phone number',
    address: 'Property Address',
    addressPlaceholder: 'Enter your property address',
    service: 'Service Needed',
    servicePlaceholder: 'Select a service',
    message: 'Message / Comments',
    messagePlaceholder: 'Tell us about your screens and what you need...',
    messageNote: '0/500',
    submit: 'Request Your Free Quote! \u2190',
    infoTitle: 'The Screen Squad',
    infoDesc: 'Professional screen and door repair, replacement, and installation service in Santa Ana, California. Fast, professional, and reliable service directly at your property.',
    infoArea: 'SERVICE AREA',
    infoAreaValue: 'Santa Ana, California\n& Surrounding Areas',
    infoHours: 'BUSINESS HOURS',
    infoHoursWeekday: 'Mon - Sat: 8:00 AM - 6:00 PM',
    infoHoursWeekend: 'Sun: Closed',
    infoWhy: 'WHY CHOOSE THE SCREEN SQUAD?',
    infoWhy1: 'Free quotes with no commitment',
    infoWhy2: 'Response in under 24 hours',
    infoWhy3: 'Guaranteed professional service',
    infoWhy4: 'Serving Santa Ana and surrounding areas',
    infoNote: 'Complete the form on the right and receive your personalized quote today.',
    mapTitle: 'Service Area - Orange County, California',
    areasTitle: 'AREAS WE SERVE',
    areasDesc: 'The Screen Squad provides screen and door services throughout Orange County, California. From Santa Ana to Newport Beach, we are ready to help.',
    areasSubtitle: 'AREAS WE SERVE',
  },
  admin: {
    loginTitle: 'Administrative Access',
    loginDesc: 'Enter your credentials to access the panel',
    user: 'Username',
    userPlaceholder: 'Enter your username',
    password: 'Password',
    passwordPlaceholder: 'Enter your password',
    submit: 'Sign In',
    panelTitle: 'Admin Panel',
    panelBrand: 'The Screen Squad',
    viewSite: 'View Site',
    logout: 'Logout',
  },
  errors: {
    formSubmitError: 'There was an error submitting the form. Please try again.',
    required: 'This field is required',
    invalidEmail: 'Please enter a valid email',
  },
  success: {
    formSubmit: 'Form submitted successfully! We will contact you soon.',
  },
};